@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.driverrating
import com.narbase.letsgo.dto.core.KmmLong

class DriverRatingDto (
    val id: KmmLong? = null,
    val driverId: KmmLong,
    val rating: Double,
    val noReview: Int
)